import React from 'react'

const FacebookIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="20" height="21" viewBox="0 0 20 21" 
    fill="none" xmlns="http://www.w3.org/2000/svg"
    {...props} >
<path d="M9.83467 0.457031C4.40318 0.457031 0 4.87647 0 10.328C0 14.9571 3.17542 18.8416 7.459 19.9084V13.3446H5.4311V10.328H7.459V9.02821C7.459 5.66852 8.97394 4.11127 12.2603 4.11127C12.8834 4.11127 13.9585 4.23407 14.3983 4.35647V7.09073C14.1662 7.06625 13.763 7.05401 13.2622 7.05401C11.6498 7.05401 11.0266 7.6672 11.0266 9.26116V10.328H14.239L13.6871 13.3446H11.0266V20.1268C15.8964 19.5365 19.6697 15.3749 19.6697 10.328C19.6693 4.87647 15.2662 0.457031 9.83467 0.457031Z" 
fill="currentColor"/>
</svg>
 
)
export default FacebookIcon